import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

/*  severity = error, warning, info ou success  */
export default function CustomSnackbar(props) {

  return (
    <div>
      <Snackbar open={props.open} autoHideDuration={1000}>
        <MuiAlert onClose={props.onClose} severity={props.type} elevation={6} variant="filled">
            {props.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
